import { render, staticRenderFns } from "./icon-twitter.vue?vue&type=template&id=1ce3f6c4&scoped=true&"
import script from "./icon-twitter.vue?vue&type=script&lang=js&"
export * from "./icon-twitter.vue?vue&type=script&lang=js&"
import style0 from "./icon-twitter.vue?vue&type=style&index=0&id=1ce3f6c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce3f6c4",
  null
  
)

export default component.exports